import { forwardRef } from 'react';
import { DayTabProps } from '@msc-b2c/interfaces/types';
import { Text } from '@msc-b2c/shared-components';
import styles from '../dayTabs.module.scss';
import { handleKeyDown } from '@msc-b2c/shared-utils';

const DayTab = forwardRef<HTMLButtonElement, DayTabProps>(
  (
    {
      id,
      tabPanelId,
      isAllPortTab,
      dayNumber,
      portName,
      allPortsLabel,
      dayPlaceHolder,
      isSelected,
      onClick,
    }: Readonly<DayTabProps>,
    ref
  ) => {
    let labelText = '';

    if (isAllPortTab && allPortsLabel) {
      labelText = allPortsLabel;
    } else if (dayPlaceHolder && dayNumber !== undefined && portName) {
      labelText = dayPlaceHolder
        .replace('{dayNumber}', String(dayNumber))
        .replace('{portName}', portName);
    }

    if (!labelText) {
      return null;
    }

    return (
      <button
        ref={ref}
        id={id}
        type="button"
        role="tab"
        className={`${styles.dayTab} ${isSelected ? styles.selectedTab : ''}`}
        onClick={onClick}
        tabIndex={0}
        onKeyDown={(event) => onClick && handleKeyDown(event, onClick)}
        aria-selected={isSelected ? 'true' : 'false'}
        aria-controls={tabPanelId}
      >
        <Text
          text={labelText}
          tagHtml="span"
        />
      </button>
    );
  }
);

export default DayTab;
